import { Link } from "react-router-dom";

import { globalT } from "../utils/globalUtils.js";

export const Error404 = () => {
  return (
    <section id="error-404">
      <div className="container">
        <img src="images/404image.png" alt="" />
        <div className="title">
          {globalT("Oops")}...
          <br></br>
          error 404
        </div>
        <div className="m-subtitle">{globalT("Página no encontrada")}</div>
      </div>
      <Link className="m-button" to="/" relative="path">
        {globalT("VOLVER AL INICIO")}
      </Link>
    </section>
  );
};
